import { faQuoteLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Paper, Typography } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { sxResolverMensagemCard } from './sxResolverPendencia';

interface Props {
  mensagem?: string;
  assinatura?: string;
  dataMensagem?: string;
}

const TranscricaoPendenciaMensagemCard: React.FC<Props> = ({
  mensagem,
  assinatura = 'Equipe de Avaliação Técnica',
  dataMensagem,
}) => {
  const accessibility = useAccessibility();
  const textoMensagem =
    mensagem?.trim() ||
    'Não há detalhes adicionais sobre a pendência no momento.';

  const rodape = [assinatura, dataMensagem].filter(Boolean).join(', ');

  return (
    <Paper
      className="transcricao-resolver-mensagem-card"
      style={accessibility.contrastBorderAccessibility}
      sx={sxResolverMensagemCard}
      variant="outlined"
    >
      <FontAwesomeIcon
        icon={faQuoteLeft as IconProp}
        className="transcricao-resolver-mensagem-icon"
        aria-hidden
      />
      <Typography
        component="p"
        className="transcricao-resolver-mensagem-texto"
        style={accessibility.textStyleAccessibility}
      >
        {textoMensagem}
      </Typography>
      {rodape && (
        <>
          <hr className="transcricao-resolver-mensagem-divisor" />
          <Typography
            component="p"
            className="transcricao-resolver-mensagem-rodape"
            style={accessibility.textStyleAccessibility}
          >
            {rodape}
          </Typography>
        </>
      )}
    </Paper>
  );
};

export default TranscricaoPendenciaMensagemCard;
